import { z } from "zod";

/** 실측: backend/app/api/v1/notifications/routes.py. payload 는 타입마다 달라 열어 둔다. */
export const notificationSchema = z.object({
  id: z.string(),
  type: z.string(),
  title: z.string(),
  body: z.string().nullable().optional(),
  payload: z.record(z.unknown()).nullable().optional(),
  readAt: z.string().nullable(),
  createdAt: z.string(),
});
export type NotificationDto = z.infer<typeof notificationSchema>;
